export default __webpack_public_path__ + "static/media/logo.24095b6e.png";